var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card-list',{attrs:{"title":"Payment Method","dataUrl":"/api/v1/payment-method","dataSize":"10","dataHeaders":_vm.tHeaders,"editRoute":"/master/payment-method/add","deleteEndpoint":"/api/v1/payment-method"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }